import {
  createErrorType,
  createFetchType,
  createSubmitType,
  createSuccessType,
  createLoadingType,
  createClearType,
} from '../actionHelpers';

// Connect bank account ACH

const CONNECT_ACH_BANK_ACCOUNTS_SCOPE = 'CONNECT_ACH_BANK_ACCOUNTS';
export const CONNECT_ACH_BANK_ACCOUNTS = createSubmitType(
  CONNECT_ACH_BANK_ACCOUNTS_SCOPE,
);
export const CONNECT_ACH_BANK_ACCOUNTS_SUCCESS = createSuccessType(
  CONNECT_ACH_BANK_ACCOUNTS_SCOPE,
);
export const CONNECT_ACH_BANK_ACCOUNTS_ERROR = createErrorType(
  CONNECT_ACH_BANK_ACCOUNTS_SCOPE,
);
export const CONNECT_ACH_BANK_ACCOUNTS_LOADING = createLoadingType(
  CONNECT_ACH_BANK_ACCOUNTS_SCOPE,
);

// get bank accounts
export const FETCH_BANK_ACCOUNTS = createFetchType('BANK_ACCOUNT');
export const FETCH_BANK_ACCOUNTS_SUCCESS = createSuccessType('BANK_ACCOUNT');
export const FETCH_BANK_ACCOUNTS_ERROR = createErrorType('BANK_ACCOUNT');
export const FETCH_BANK_ACCOUNTS_LOADING = createLoadingType('BANK_ACCOUNT');

// clear bank accounts

export const CLEAR_BANK_ACCOUNTS_STATE = createClearType(
  CONNECT_ACH_BANK_ACCOUNTS_SCOPE,
);
